import { render, staticRenderFns } from "./addgoods.vue?vue&type=template&id=03cdf5aa&scoped=true&"
import script from "./addgoods.vue?vue&type=script&lang=js&"
export * from "./addgoods.vue?vue&type=script&lang=js&"
import style0 from "./addgoods.vue?vue&type=style&index=0&id=03cdf5aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdf5aa",
  null
  
)

export default component.exports